"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A filter component for years
 *
 * @param {object} props Properties used for the component
 *
 * @returns {React.ReactElement} PressReleaseFilter
 */
function PressReleaseFilter(props) {
  var handleChange = itm => {
    var cBox = [...props.curTopics];
    var idx = props.curTopics.indexOf(itm);
    if (idx === -1) {
      cBox.push(itm);
    } else {
      cBox.splice(idx, 1);
    }
    cBox.length >= 1 ? window.history.pushState({
      path: "".concat(props.params.pagePath, "?category=").concat(cBox.join('|'))
    }, '', "".concat(props.params.pagePath, "?category=").concat(cBox.join('|'))) : window.history.pushState({
      path: "".concat(props.params.pagePath)
    }, '', "".concat(props.params.pagePath));
    props.handleCheckbox(cBox);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "pr86v1256",
    className: "app-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-text"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Filter by:"), /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled"
  }, (0, _lodash.map)(props.rendering.fields.TopicList, (item, index) => {
    var isChecked = Array.isArray([props.curTopics]) && props.curTopics.length > 0 ? props.curTopics.indexOf(item.fields.Key.value) != -1 ? true : false : false;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: "".concat(item.id),
      className: "custom-control custom-checkbox"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: "custom-control-input",
      type: "checkbox",
      id: "custbox".concat(item.id),
      name: item.fields.Key.value,
      value: item.fields.Value.value,
      checked: isChecked,
      onChange: () => handleChange(item.fields.Key.value)
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: "custom-control-label",
      htmlFor: "custbox".concat(item.id)
    }, item.fields.Value.value));
  }))))));
}
var _default = exports.default = PressReleaseFilter;